import Button from "../../../Buttons/Button";
import React, {
  FormEvent,
  useCallback,
  useRef,
  useState,
} from "react";
import { useForm } from "react-hook-form";
import { inactiveItens, secondary } from "../../../../theme";
import { useApi } from "../../../../hooks/api";
import { useGlobal } from "../../../../hooks/global";
import { ModalLoading } from "../../../Loadings/ModalLoading";
import { IGroupProps } from "../../../../interfaces";
import { ContainerButtons, Form } from "./style";
import { GenericForm, IGenericFormRefProps } from "../../../GenericForm";
import { permissionsBusinessOptions, planIconsOptions, positionTypeOptions } from "../../../../utils/options";

export interface IGuestsDocumentsCardRef {
  matchImages: () => Promise<{
    isVerified: any;
    idGuest: string | undefined;
    compareValid: any;
    compareScore: any;
  }>;
}

interface IFormBusinessModalProps {
  onCancel: Function;
  onSave: Function;
  defaultData?: any;
}

export const FormPlan: React.FC<IFormBusinessModalProps> = (
  props
) => {
  const { onSave, defaultData, onCancel } = props;

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setError,
    setValue,
    trigger,
    unregister,
    clearErrors,
  } = useForm({
    defaultValues: defaultData?.id ? defaultData : ({} as any),
    mode: "all",
  });

  const _form = watch();

  const { api } = useApi();
  const { theme, notify, notifyBottom } = useGlobal();

  const [loadingSave, setLoadingSave] = useState(false);

  const form_ref = useRef<IGenericFormRefProps>(null)
  const buttonSubmitRef = useRef<HTMLButtonElement>(null)

  const onSubmit = useCallback(async (event) => {
    setLoadingSave(true)

    const form = form_ref.current?.getForm()

    const { value, value_extra_accommodation, permissions } = form;

    const permissionValues = permissions.map((permission: any) => permission.id);

    const data = {
      ...form,
      permissions: permissionValues,
      value: value?.toFixed(2),
      value_extra_accommodation: value_extra_accommodation?.toFixed(2)
    };

    try {
      if (defaultData?.id) {
        await api.put(`/plan/${defaultData?.id}`, { ...data });
      } else {
        await api.post("/plan", data);
      }

      if (defaultData?.id) notify("Plano atualizado com sucesso", "success");
      else notify('Plano cadastrada com sucesso!', "success");

      onSave();
    } catch (err: any) {
      const error = err.response ? err.response.data : "SERVER ERROR";

      if (error.field) {
        setError(error.field, { type: "manual", message: error.detail });
      }

      if (error.path) setError(error.path, { type: "manual", message: error.message })
      else notify("ERRO INTERNO DO SISTEMA", "error")
    }

    setLoadingSave(false)

  }, [form_ref, api, _form])

  const handleStopPropagation = useCallback((e: FormEvent<HTMLFormElement>) => {
    e?.stopPropagation()
    handleSubmit(onSubmit)(e)
  }, [handleSubmit, onSubmit, form_ref, _form, api])

  const groups: IGroupProps[] = [
    {
      name: "",
      label: "",
      fields: [
        [
          {
            name: "name",
            label: "Nome",
            type: "input",
            required: true,
            getIsDisabled: () => !!defaultData?.id
          },
          {
            name: "icon",
            label: "Ícone",
            type: "select-fixed",
            options: planIconsOptions,
            required: true,
            getIsDisabled: () => !!defaultData?.id
          },
        ],
        [
          {
            name: "minimum_quantity_accommodation",
            label: "QTD mínima de acomodações",
            type: "input",
            mask: 'int',
            required: true,
            getIsDisabled: () => !!defaultData?.id
          },
          {
            name: "value",
            label: "Valor",
            type: "input",
            mask: "currency",
            required: true,
            getIsDisabled: () => !!defaultData?.id
          },
          {
            name: "value_extra_accommodation",
            label: "Valor por acomodação extra",
            type: "input",
            mask: "currency",
            required: true,
            getIsDisabled: () => !!defaultData?.id
          },
        ],
        [

          {
            name: "recurrence",
            label: "Recorrência",
            type: "input",
            required: true,
            mask: 'int',
            getIsDisabled: () => !!defaultData?.id
          },
          {
            name: "frequency",
            label: "Frequência",
            type: "input",
            mask: 'int',
            required: true,
            getIsDisabled: () => !!defaultData?.id
          }
        ],
        [
          {
            name: "permissions",
            label: "Permissões",
            type: "select-fixed-multi",
            options: permissionsBusinessOptions,
            required: true
          },
        ],
        [
          {
            name: "description",
            label: "Descrição",
            type: "textarea",
            required: true,
            numberOfRows: 10
          },
        ]
      ],
    },
  ]

  return (
    <>
      <Form onSubmit={handleStopPropagation}>
        <GenericForm
          ref={form_ref}
          groups={groups}
          _form={_form}
          control={control}
          trigger={trigger}
          errors={errors}
          setValue={setValue}
          register={register}
          disabled={loadingSave}
        />

        <button
          ref={buttonSubmitRef}
          type="submit"
          style={{ display: "none" }}
        />
      </Form>
      <ContainerButtons theme={theme}>
        <Button
          onClick={() => onCancel()}
          background={inactiveItens[theme]}
          color={"#FFF"}
          style={{ padding: 8, maxWidth: 150, fontSize: 14 }}
          children="Voltar"
        />

        <Button
          onClick={() => buttonSubmitRef.current?.click()}
          background={secondary[theme]}
          color={"#FFF"}
          style={{ padding: 8, maxWidth: 150, fontSize: 14 }}
          children="Salvar"
        />
      </ContainerButtons>

      <ModalLoading loading={loadingSave} theme={theme} />
    </>
  );
};
